const garage = localStorage.getItem('garage');

export const GarageLocationStore = {
    data: {
        garages: new Array<any>(),
        hasAllGarages: false,
        garageDetails: new Array<any>(),
        hasGarageDetails: false,
        vehicleGarages: new Array<any>(),
        userGarages: new Array<any>(),
        userGarage: garage,
        garageName: '',
        garageUnits: '',
        garageErrors: ''
    },
    methods: {
        updateGarageSelections(data: []) {
            GarageLocationStore.data.garages = data;
            GarageLocationStore.data.hasAllGarages = true;
        },
        updateGarageDetails(data: []) {
            GarageLocationStore.data.garageDetails = data;
            GarageLocationStore.data.hasGarageDetails = true;
        },
        updateVehicleGarages(data: []) {
            GarageLocationStore.data.vehicleGarages = data;
        },
        //updates the user garages ids
        updateUserGarages(data: []) {
            GarageLocationStore.data.userGarages = data;
        },
        updateUserGarage(data: string) {
            GarageLocationStore.data.userGarage = data;
            localStorage.setItem('garage', data);
        },
        getGarageName(id: string) {
            const g = GarageLocationStore.data.garages.find(x => x.id == id);
            return g ? g.location : null;
        },
        getSelectedGarage() {
            const g = GarageLocationStore.data.garages.find(x => x.id == GarageLocationStore.data.userGarage);
            return g;
        },
        getCalendarUtilisation(id: string) {
            const g = GarageLocationStore.data.garages.find(x => x.id == id);
            return g && g.calendarUtilisationBands != null ? g.calendarUtilisationBands : [1, 10, 20];
        },
        updateGarageSummary(name: string, units: string, errors: string) {
            GarageLocationStore.data.garageName = name;
            GarageLocationStore.data.garageUnits = units;
            GarageLocationStore.data.garageErrors = errors;
        },
        hasSelectedGarage() {
            if (!GarageLocationStore.data.userGarage) { return false; }
            const garages = GarageLocationStore.data.userGarages;
            if (!garages) { return false; }
            const g = GarageLocationStore.data.userGarages.find(x => x == GarageLocationStore.data.userGarage);
            return !!g;
        }
    }
};
